import { render, staticRenderFns } from "./GameEnd.vue?vue&type=template&id=349b2501&scoped=true&"
import script from "./GameEnd.vue?vue&type=script&lang=js&"
export * from "./GameEnd.vue?vue&type=script&lang=js&"
import style0 from "./GameEnd.vue?vue&type=style&index=0&id=349b2501&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b2501",
  null
  
)

export default component.exports